module.exports = {
          srcSet: __webpack_public_path__ + "baadf316a98afa37ed7535f374a62a6b-570.png"+" 570w",
          images:[ {path: __webpack_public_path__ + "baadf316a98afa37ed7535f374a62a6b-570.png",width: 570,height: 335}],
          src: __webpack_public_path__ + "baadf316a98afa37ed7535f374a62a6b-570.png",
          toString:function(){return __webpack_public_path__ + "baadf316a98afa37ed7535f374a62a6b-570.png"},
          
          width: 570,
          height: 335
        }